import React, { useCallback, useRef, useState } from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { Box } from '@mui/material';
import { useClickOutside } from '@hooks';

const isValidHex6 = (val) => {
  // Accepts only 6 hex digits, with or without a leading '#'
  const hex = val.replace(/^#/, '');
  return hex.length === 6 && /^[0-9a-fA-F]+$/.test(hex);
};

const PopoverColorPicker = ({ color, onChange }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);
  const [inputValue, setInputValue] = useState(color || '');
  const [error, setError] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  const handleColorChange = (val) => {
    setInputValue(val);
    if (isValidHex6(val)) {
      setError(false);
      onChange(val);
    } else {
      setError(true);
    }
  };

  return (
    <Box className="picker">
      <Box
        className="swatch"
        style={{ backgroundColor: color }}
        onClick={() => toggle(true)}
      />

      {isOpen && (
        <Box className="popover" ref={popover}>
          <HexColorPicker color={inputValue} onChange={handleColorChange} />
          <HexColorInput color={inputValue} onChange={handleColorChange} />
          {error && (
            <Box sx={{ color: 'red', fontSize: 12, pl: '8px' }}>
              Please enter 6 hex digits
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

const memoizedPopoverColorPicker = React.memo(PopoverColorPicker);
export { memoizedPopoverColorPicker as PopoverColorPicker };

export default memoizedPopoverColorPicker;
